import React from "react";
import { useTranslation } from "react-i18next";
import { FiCheckCircle, FiAlertCircle, FiX, FiFile } from "react-icons/fi";
import { KIND_ICONS, fileKind, formatBytes } from "./fileKinds";

/**
 * File rows with per-file progress.
 * items: [{ name, size, status: "selected"|"queued"|"uploading"|"done"|"error", uploaded, error }]
 */
export default function UploadProgressList({ items, onRemove }) {
  const { t } = useTranslation();
  if (!items.length) return null;

  return (
    <ul className="shr-files">
      {items.map((item, i) => {
        const kind = fileKind(item.name);
        const Icon = KIND_ICONS[kind] || FiFile;
        const pct = item.size ? Math.min(100, Math.round(((item.uploaded || 0) / item.size) * 100)) : 0;
        const showBar = item.status === "uploading" || item.status === "queued";

        return (
          <li key={`${item.name}-${i}`} className="shr-file">
            <span className={`shr-file-icon ${kind || ""}`}><Icon size={16} /></span>
            <div className="shr-file-body">
              <div className="shr-file-name" title={item.name}>{item.name}</div>
              {item.status === "error" ? (
                <div className="shr-file-meta error">{item.error || t("share.upload.file_failed")}</div>
              ) : (
                <div className="shr-file-meta">
                  {formatBytes(item.size)}
                  {item.status === "uploading" && ` · ${pct}%`}
                </div>
              )}
              {showBar && (
                <div className="shr-progress"><span style={{ width: `${pct}%` }} /></div>
              )}
            </div>
            {item.status === "done" && <span className="shr-file-status done"><FiCheckCircle size={18} /></span>}
            {item.status === "error" && <span className="shr-file-status" style={{ color: "#ef4444" }}><FiAlertCircle size={18} /></span>}
            {item.status === "selected" && onRemove && (
              <button type="button" className="shr-icon-btn" onClick={() => onRemove(i)} aria-label={t("share.upload.remove")}>
                <FiX size={14} />
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
